import React from 'react';
import contactData from '../data/contact.json';

const ContactUs: React.FC = () => {
  return (
    <section id="contact">
      <h2>Contact Us</h2>
      <p>Address: {contactData.address}</p>
      <p>Phone: {contactData.phone}</p>
      <p>Email: {contactData.email}</p>
      <h3>Hours</h3>
          <ul>
            {contactData.hours.map((item, index) => (
              <ul key={index}>{item.day}: {item.time}</ul>
            ))}
          </ul>
      <h3>Find Us on Google Maps:</h3>
      <div style={{ width: '100%', height: '300px', overflow: 'hidden', borderRadius: '8px' }}>
        <iframe
          src="https://maps.google.com/maps?q=Chalo+Dilli+Paratha+Cafe,+18.6127899,73.9062966&output=embed"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen={true}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Google Map of Chalo dilli Paratha Cafe"
        ></iframe>
      </div>
    </section>
  );
};

export default ContactUs;
